import React from "react";
import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import Text from "@components/Text";
import { themeDefault } from "src/theme-revamp";
import Button from "../Button";

export interface EditModalProps {
  onNoClick?: () => void;
  onYesClick?: () => void;
}

function ConsentChangeModal({
  onYesClick,
  onNoClick,
  ...props
}: EditModalProps) {
  return (
    <Container>
      <FormHeaderContainer>
        <FormHeaderTitleContainer marginHorizontal={"60px"}>
          <Text
            align={"center"}
            theme={themeDefault}
            className={HeaderTitleCss}
          >
            Need to make changes?
          </Text>
          <Text align={"center"} theme={themeDefault} className={TextCss}>
            Your inputs will not be saved if you change your option now. Would
            you like to proceed?
          </Text>
        </FormHeaderTitleContainer>
      </FormHeaderContainer>
      <FormContentContainer>
        <Button
          onClick={() => {
            if (onNoClick) {
              onNoClick();
            }
          }}
          width={"180px"}
          variant={"secondary"}
          theme={themeDefault}
          label={"No"}
        ></Button>
        <Button
          onClick={() => {
            if (onYesClick) {
              onYesClick();
            }
          }}
          width={"180px"}
          variant={"default"}
          theme={themeDefault}
          label={"Yes"}
        ></Button>
      </FormContentContainer>
    </Container>
  );
}

export default ConsentChangeModal;

const Container = styled.div`
  /* width: 636px;
  height: 280px; */
`;

const HeaderTitleCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 28px;
  line-height: 140%;
  color: #434343;
  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

const TextCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  color: #8a8988;
  margin-top: 16px (max-width: 768px) {
    font-weight: 400;
  } ;
`;

const FormHeaderContainer = styled.div`
  display: block;
  margin-bottom: 48px;
  @media screen and (max-width: 767.98px) {
    display: flex;
    flex-direction: column;
    row-gap: 16px;
  }
`;

const FormContentContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 10px;

  flex-direction: row;
  justify-content: center;
  @media screen and (min-width: 768px) {
    flex-direction: column;
    column-gap: 30px;
    flex-direction: row;
    justify-content: center;
  }
`;

const FormHeaderTitleContainer = styled.div<FormHeaderTitleContainerProps>`
  display: block;
  margin: 0 ${(props) => props.marginHorizontal};
  margin-bottom: 16px;
  @media screen and (max-width: 768px) {
    padding: 0 20px;
    margin: 0 20px;
  }
`;

export interface FormContainerProps {
  margin?: string;
}

export interface FormHeaderTitleContainerProps {
  marginHorizontal: string;
}
